import { FormGroup } from '@angular/forms';

export class ValidationHelper {

  static allowNumbersOnly(
    event: Event,
    form: FormGroup,
    controlPath: string,
    maxLength: number = 10
  ): void {
    const input = event.target as HTMLInputElement;

    const numericValue = input.value.replace(/\D/g, '').slice(0, maxLength);

    input.value = numericValue;

    form.get(controlPath)?.setValue(numericValue, {
      emitEvent: false
    });
  }
}